<!--温度和漏电实时值-->
<template>
	<div class="weduRtChartBody">
		<div class="wendu-chart">
			<el-select v-model="wenduValue" placeholder="请选择">
				<el-option v-for="item in wenduOptions" :key="item.lable" :label="item.lable" :value="item.lable">
				</el-option>
			</el-select>
			<vchart ref='wenduVchart' style=''></vchart>
		</div>
		<div class="loudian-chart">
			<el-select v-model="loudianValue" placeholder="请选择">
				<el-option v-for="item in loudianOptions" :key="item.lable" :label="item.lable" :value="item.lable">
				</el-option>
			</el-select>
			<vchart ref='loudianVchart'></vchart>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: ['wenduOptions', 'loudianOptions', 'nowVariableNames'],
		data() {
			return {
				loudianValue: '',
				wenduValue: '',
				options: {
					title: {
						text: "",
						left: 'center',
						textStyle: {
							fontWeight: 800,
							fontSize: 22,
						}
					},
					tooltip: {},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '50',
						top: '10'
					},
					xAxis: {
						type: 'time',
						splitLine: {
							show: true
						},
						axisLabel: {
							textStyle: {
								color: 'black',
							},
						},
						data: [],
					},
					yAxis: {
						type: 'value',
						scale: true,
						showMaxLabel: true,
					},
					series: []
				},
				wedoOptions: {},
				loudianOption: {}
			}
		},
		mounted() {
			this.wedoOptions = copy(this.options)
			this.loudianOption = copy(this.options)
			this.$refs.wenduVchart.setData(this.wedoOptions, true)
			this.$refs.loudianVchart.setData(this.loudianOption, true)
			if(!isempty(this.wenduOptions)) {
				this.wenduValue = this.wenduOptions[0].lable
			}
			if(!isempty(this.loudianOptions)) {
				this.loudianValue = this.loudianOptions[0].lable
			}
			//判断不为空才开启
			if(!isempty(this.wenduOptions)) {
				addNewTask('weduRtValue', 100000, 2000, -1, () => {
					this.weduRtValueData()
				})
			}
			if(!isempty(this.loudianOptions)) {
				addNewTask('loudianRtValue', 100000, 2000, -1, () => {
					this.loudianRtvalueData()
				})
			}
		},
		destroyed() {
			removeTask('weduRtValue')
			removeTask('loudianRtValue')
		},
		computed: {},
		watch: {
			loudianValue(nv, ov) {
				this.loudianRtvalueData()
			},
			wenduValue(nv, ov) {
				this.weduRtValueData()
			},
			wenduOptions(nv,ov){
				if(!isempty(nv)){
					this.wenduValue = this.wenduOptions[0].lable
				}
			},
			loudianOptions(nv,ov){
				if(!isempty(nv)){
					this.loudianValue = this.loudianOptions[0].lable
				}
			}
		},
		methods: {
			weduRtValueData() {
				let variable = ''
				let dayTime = new Date().format('yyyy-MM-dd')
				let startTime = new Date(dayTime + ' 00:00:00').getTime()
				let endTime = new Date().getTime()
				let day = new Date().format('yyyyMMdd')
				this.nowVariableNames.forEach(item => {
					if(item.indexOf(this.wenduValue) > -1) {
						variable = item
					}
				})
				let count = ((endTime - startTime) / 1000 / 60 / 5).toFixed(0)
				if(isempty(variable)) {
					console.log("变量名为空")
					return
				}
				this.$api.historyApi.searchVariableHistory(variable, startTime, endTime, respon => {
					if(!isempty(respon)) {
						let data = []
						respon[variable][day]['data'].forEach(item => {
							if(item != null) {
								data.push(item)
							}
						})
						this.wedoOptions.xAxis = {
							type: 'category',
							splitLine: {
								show: true
							},
							axisLabel: {
								textStyle: {
									color: 'black',
								},
								showMaxLabel: true,
							},
							data: this.getDateArray('', '', data.length),
						}
						this.wedoOptions.series = [{
							data: data,
							type: 'line',
							name: '温度实时值'
						}]
						this.$refs.wenduVchart.setData(this.wedoOptions, true)
					}

				})
			},
			loudianRtvalueData() {
				let variable = ''
				let dayTime = new Date().format('yyyy-MM-dd')
				let startTime = new Date(dayTime + ' 00:00:00').getTime()
				let endTime = new Date().getTime()
				let day = new Date().format('yyyyMMdd')
				this.nowVariableNames.forEach(item => {
					if(item.indexOf(this.loudianValue) > -1) {
						variable = item
					}
				})
				let count = ((endTime - startTime) / 1000 / 60 / 5).toFixed(0)
				if(isempty(variable)) {
					console.log("变量名为空")
					return
				}
				this.$api.historyApi.searchVariableHistory(variable, startTime, endTime, respon => {
					if(!isempty(respon)) {
						let data = []
						respon[variable][day]['data'].forEach(item => {
							if(item != null) {
								data.push(item)
							}
						})
						this.loudianOption.xAxis = {
							type: 'category',
							splitLine: {
								show: true
							},
							axisLabel: {
								textStyle: {
									color: 'black',
								},
								showMaxLabel: true,
							},
							data: this.getDateArray('', '', data.length),
						}
						this.loudianOption.series = [{
							data: data,
							type: 'line',
							name: '漏电实时值'
						}]
						console.log()
						this.$refs.loudianVchart.setData(this.loudianOption, true)
					}

				})

			},
			getDateArray(endDate, splitTime, count) {
				if(!endDate) {
					endDate = new Date();
				}
				if(!splitTime) {
					splitTime = 5 * 60 * 1000;
				}
				if(!count) {
					count = 288;
				}
				var endTime = endDate.getTime();
				var mod = endTime % splitTime;
				if(mod > 0) {
					endTime -= mod;
				}
				var dateArray = [];
				while(count-- > 0) {
					var d = new Date();
					d.setTime(endTime - count * splitTime);
					dateArray.push(new Date(d).format('hh:mm'));
				}
				return dateArray;
			}
		}
	}
</script>

<style scoped>
	.weduRtChartBody {
		width: 100%;
		height: 100%;
	}
	
	.weduRtChartBody .default-chart {}
</style>